import { dashboardApi } from '../api/modules/dashboard.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { peopleMasterSeed } from '../data/master/people';
import { vendorMasterSeed } from '../data/master/vendors';
import { indentSeed } from '../data/master/indents';
import { getAssets } from '../data/master/equipmentAssetsStore';

function mockCounts() {
  const villagers = peopleMasterSeed.filter((p) => p.active !== false);
  const vendors = vendorMasterSeed.filter((v) => v.active !== false);
  const equipment = getAssets();
  const indents = indentSeed;

  const countStatus = (list, key, value) =>
    list.filter((row) => String(row[key] || '').toLowerCase() === value).length;

  return {
    villagers: {
      total: villagers.length,
      pendingKyc: countStatus(villagers, 'verificationStatus', 'pending'),
      verified: countStatus(villagers, 'verificationStatus', 'verified'),
    },
    vendors: {
      total: vendors.length,
      pending: countStatus(vendors, 'verificationStatus', 'pending'),
      verified: countStatus(vendors, 'verificationStatus', 'verified'),
      blocked: countStatus(vendors, 'verificationStatus', 'blocked'),
    },
    equipment: {
      total: equipment.length,
      available: countStatus(equipment, 'operationalStatus', 'available'),
      deployed: countStatus(equipment, 'operationalStatus', 'deployed'),
      pendingKyc: countStatus(equipment, 'status', 'pending'),
    },
    indents: {
      total: indents.length,
      pending: countStatus(indents, 'status', 'pending'),
      recommended: countStatus(indents, 'status', 'recommended'),
      assigned: countStatus(indents, 'status', 'assigned'),
      released: countStatus(indents, 'status', 'released'),
      cancelled: countStatus(indents, 'status', 'cancelled'),
    },
  };
}

export async function getDashboardCounts() {
  if (!USE_API) return mockCounts();
  try {
    return await dashboardApi.getCounts();
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load dashboard'));
  }
}

export async function getVillageSummary() {
  if (!USE_API) {
    // Seed mode: empty — village summary needs live assignment data.
    return [];
  }
  try {
    const rows = await dashboardApi.villageSummary();
    return (Array.isArray(rows) ? rows : []).map((row) => ({
      villageId: row.villageId ?? null,
      villageCode: row.villageCode || '',
      villageName: row.villageName || '',
      equipmentCount: Number(row.equipmentCount) || 0,
      recommendedCount: Number(row.recommendedCount) || 0,
      deployedCount: Number(row.deployedCount) || 0,
      releasedCount: Number(row.releasedCount) || 0,
      avgRating: row.avgRating != null ? Number(row.avgRating) : null,
    }));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load village summary'));
  }
}
